import React from 'react';
import './CalculatorPage.css'; // Importing the CSS file for styling

// Importing necessary components
import { Calculator, PageTitle } from '../../../components';

const CalculatorPage = () => { 

  return (
    <>

      {/* Page Title Section */}
      <PageTitle title={'Cost Calculator'} page={'Cost Calculator'} /> 

      {/* Cost Calculator Component */}
      <Calculator />

    </>
  );
}

export default CalculatorPage;